import React from 'react'
import {connect} from 'react-redux'
import PropTypes from 'prop-types';

import {getErrorMessage} from '../selectors/error-selector'

export const ErrorImpl = (props) => (
  <React.Fragment>
    <h2>Error</h2>
      Something is wrong: <span id="errorMessage">{props.errorMessage}</span>
  </React.Fragment>
)

const mapStateToProps = state => ({
  errorMessage: getErrorMessage(state),
});

ErrorImpl.propTypes = {
  errorMessage: PropTypes.string.isRequired,
};

export const Error = connect(mapStateToProps)(ErrorImpl);

